import { render, staticRenderFns } from "./TagNavigation.vue?vue&type=template&id=baf3c86e&scoped=true&lang=html&"
import script from "./TagNavigation.vue?vue&type=script&lang=js&"
export * from "./TagNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf3c86e",
  null
  
)

export default component.exports